import React, { useState, useEffect, useRef } from "react";
import { Route } from "react-router-dom";

import { API, graphqlOperation } from "aws-amplify";
import { accountByActiveByNameDropDown } from "../../../graphql/account/account-queries";
import { inventoryByStatusByAccount } from "../../../graphql/inventory/custom-queries";

import { CircularProgress, Grid, TextField, Backdrop } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { green, grey, orange } from "@material-ui/core/colors";
import Autocomplete from "@material-ui/lab/Autocomplete";

import { useNotify, Title } from "react-admin";

import CrewCard from "../../../components/common/CrewCard";
import { InventoryMapOutlinedIcon } from "../../../components/common/iconography";
import InventoryCard from "../../../components/common/InventoryCard";
import { InventoryStatus } from "../../../utils/constants";
import { logError } from "../../../utils/appUtils";

const useStyles = makeStyles((theme) => ({
  locationContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  locationItem: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  locationEmptyAvatar: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    minWidth: theme.spacing(12),
    color: theme.palette.getContrastText(green[200]),
    padding: theme.spacing(1),
    minHeight: theme.spacing(12),
    backgroundColor: green[200],
    margin: theme.spacing(1),
  },
  locationSelectedAvatar: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    minWidth: theme.spacing(12),
    color: theme.palette.getContrastText(orange[200]),
    padding: theme.spacing(1),
    minHeight: theme.spacing(12),
    backgroundColor: orange[200],
    margin: theme.spacing(1),
  },
  locationAvatar: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    minWidth: theme.spacing(12),
    color: theme.palette.getContrastText(grey[200]),
    padding: theme.spacing(1),
    minHeight: theme.spacing(12),
    backgroundColor: grey[200],
    margin: theme.spacing(1),
  },
  backdrop: {
    zIndex: 90001,
  },
  selectAccount: {
    display: "flex",
    justifyContent: "center",
    marginTop: theme.spacing(2),
  },
  inventoryCard: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: theme.spacing(2),
    margin: theme.spacing(1),
  },
  searchField: {
    minWidth: "20rem",
  },
}));

const YardLocations = ({ match }) => {
  return (
    <>
      <Route
        path={`${match.path}/:id`}
        render={(props) => <InventoryCard {...props} />}
      />
      <Route
        path={`${match.path}`}
        exact
        render={(props) => <MyYardLocations {...props} />}
      />
    </>
  );
};

const MyYardLocations = (props) => {
  return (
    <>
      <Title title=" Inventory Map" />
      <CrewCard
        title="Inventory Map"
        icon={<InventoryMapOutlinedIcon fontSize="large" />}
      >
        <InventoryMapContent {...props} />
      </CrewCard>
    </>
  );
};

const InventoryMapContent = ({
  account,
  setLocation,
  setAuditAccount,
  setAuditLocations,
  match,
}) => {
  const SELECT_AN_ACCOUNT = "Select an account";
  const [loading, setLoading] = useState();
  const [value, setValue] = useState(
    account ? account : { id: null, businessName: SELECT_AN_ACCOUNT }
  );
  const [inputValue, setInputValue] = useState("");
  const [allAccounts, setAllAccounts] = useState([]);
  const [accountLocations, setAccountLocations] = useState([]);
  const [locations, setLocations] = useState([]);
  const [aisles, setAisles] = useState([]);
  const [aisleMap, setAisleMap] = useState([]);
  const [selectedAisle, setSelectedAisle] = useState();
  const isComponentMounted = useRef(true);
  const notify = useNotify();
  const classes = useStyles();

  useEffect(() => {
    getAccounts();
    return () => (isComponentMounted.current = false);
  }, []);

  const getAccounts = async () => {
    try {
      const response = await API.graphql(
        graphqlOperation(accountByActiveByNameDropDown, {
          reloadYardId: window.appUser?.reloadYardId,
          activeBusinessName: { beginsWith: { active: "true" } },
        })
      );
      isComponentMounted &&
        setAllAccounts([
          { id: null, businessName: SELECT_AN_ACCOUNT },
          ...response.data.accountByActiveByName.items.map((acct) => {
            return { id: acct.id, businessName: acct.businessName };
          }),
        ]);
    } catch (err) {
      logError("Locations:YardLocations:getAccounts", err, notify);
    }
  };

  const getInventories = async (accountName) => {
    setLoading(true);
    try {
      let query = {
        reloadYardId: window.appUser.reloadYardId,
        statusAccountNameProductNameLotNumber: {
          beginsWith: {
            status: InventoryStatus.STORED,
            accountName: accountName,
          },
        },
        limit: 1000,
      };
      let resp = await API.graphql(
        graphqlOperation(inventoryByStatusByAccount, query)
      );
      let inventoryData =
        resp.data.inventoryByStatusByAccountByProductByLot.items;
      const result = {};
      const LocationMap = {};
      const aisleMap = {};

      debugger;
      inventoryData.forEach((itm) => {
        if (itm.location) {
          itm.location.aisle.area = itm.location.area;
          itm.location.aisle.zone = itm.location.zone;
          aisleMap[itm.location.aisleId] = itm.location.aisle;
          LocationMap[itm.location.id] = itm.location;

          if (!result[itm.location.aisleId])
            result[itm.location.aisleId] = { quantity: 0 };
          if (!result[itm.location.aisleId][itm.accountId])
            result[itm.location.aisleId][itm.accountId] = [];
          result[itm.location.aisleId][itm.accountId].push(itm);
          result[itm.location.aisleId].quantity =
            result[itm.location.aisleId][itm.accountId].length;
        }
      });

      setAisleMap(aisleMap);
      const ailses = Object.values(aisleMap);
      setAisles(ailses);

      result.createdAt = new Date().toISOString();
      const accountLocations = Object.values(aisleMap);
      debugger;
      setLocations(result);
      setAccountLocations(accountLocations);
      return result;
    } catch (err) {
      logError("Locations:YardLocations:getInventories", err, notify);
    } finally {
      setLoading(false);
    }
  };

  const setSelectedAccount = async (newValue, locations) => {
    setValue(newValue);

    if (setAuditAccount) setAuditAccount(newValue);
    if (!newValue || newValue.businessName === SELECT_AN_ACCOUNT) {
      setAccountLocations([]);
      if (setAuditLocations) setAuditLocations([]);
    } else {
      await getInventories(newValue.businessName);
    }
    setSelectedAisle("");
  };

  const selectLocation = (locationId) => {
    setSelectedAisle(locationId);

    if (setLocation) setLocation(locationId);
  };

  const getAvatarClass = (locationId) => {
    if (!locationId) return classes.locationAvatar;
    let avatarClass = classes.locationEmptyAvatar;
    if (locationId === selectedAisle)
      avatarClass = classes.locationSelectedAvatar;
    else {
      const qty = locations[locationId] ? locations[locationId].quantity : 0;
      if (qty > 0) {
        avatarClass = classes.locationAvatar;
      }
    }
    return avatarClass;
  };

  const setAccountInputValue = (event, newInputValue) => {
    setInputValue(newInputValue);
  };

  return loading ? (
    <Backdrop className={classes.backdrop} open={loading}>
      <CircularProgress color="inherit" />
    </Backdrop>
  ) : (
    <>
      <Grid container justifyContent="center" alignItems="center">
        <Grid item xs={12}>
          <div className={classes.selectAccount}>
            <Autocomplete
              id="accounts"
              defaultValue={value}
              inputValue={inputValue}
              options={allAccounts}
              getOptionLabel={(option) => option.businessName}
              onChange={(event, newValue) =>
                setSelectedAccount(newValue, locations)
              }
              onInputChange={setAccountInputValue}
              className={classes.searchField}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select account"
                  size="small"
                  variant="outlined"
                />
              )}
            />
          </div>
        </Grid>
      </Grid>
      {selectedAisle && (
        <Grid container spacing={2}>
          {locations[selectedAisle] &&
            Object.keys(locations[selectedAisle]).map((key) =>
              key === "quantity"
                ? null
                : locations[selectedAisle][key].map((itm) => (
                    <InventoryCard key={itm.id} itm={itm} match={match} />
                  ))
            )}
        </Grid>
      )}
    </>
  );
};

// export const InventoryMap = ({account, setLocation}) => (
// 	<MyYardLocations account={account} setLocation={setLocation} />
// )

export const AuditMap = ({ setAuditAccount, setAuditLocations }) => (
  <InventoryMapContent
    setAuditAccount={setAuditAccount}
    setAuditLocations={setAuditLocations}
  />
);

const LocationSearch = (props) => <YardLocations {...props} />;
export default LocationSearch;
